import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { DarkModeProvider } from './contexts/DarkModeContext';
import { TraceApp } from './TraceApp';

/**
 * Main App component for standalone mode.
 * This wraps TraceApp with necessary providers for standalone operation.
 */
const App: React.FC = () => {
  return (
    <DarkModeProvider>
      <BrowserRouter future={{ v7_startTransition: true }}>
        <TraceApp />
      </BrowserRouter>
    </DarkModeProvider>
  );
};

export default App;

